import { computed, provide, reactive } from "vue"
import { QueryStringDataModel } from "@/core/QueryString/QueryStringDataModel"

// flows
import loadConfigService from "./flows/loadConfig"
// import loadUserService from "./flows/loadUser"

/**
 * 
 * @param {*} options 
 * @param {*} accountStore 
 * @param {*} localeStore 
 * @returns 
 */
export const CallbackFlow = function (options = {}, accountStore, localeStore) {

    const states = reactive({
        mainAppName: options?.mainAppName ?? "",
        blobWebLanding: null,
        blobUrl: "",
        query: null,
    })

    const events = reactive({
        onReady: () => true,
        onError: () => true
    })

    const isPageReady = computed(() => {
        // check data is all load
        if (states.query && states.blobWebLanding != null) {
            return true
        }
        return false
    })

    //#region methods

    const init = async function () {
        // initial theme
        let cacheQs = new QueryStringDataModel().loadCache()
        console.log(cacheQs)
        states.query = cacheQs
        localeStore.setters.setLocale(cacheQs.locale);

        const configService = loadConfigService(states, localeStore)
        // const userService = loadUserService(states)

        try {
            await configService.getBlobApiConfig()
            events.onReady(isPageReady)
        } catch (error) {
            events.onError(error)
        }
    }
    //#endregion

    provide("LandingStates", states)

    return {
        states,
        isPageReady,
        events,
        init,
    }
}

export default CallbackFlow
